export type InteractionPolicy = 'enabled' | 'passive';

export interface InteractionPolicyProps {
  interactionPolicy?: InteractionPolicy;
}
